const config = {
  baseUrl: 'https://api.dimorder.com',
  mpUrl: 'https://mp-order.dimorder.com',
}

export default config
